import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import qs from "qs";
import { Toast } from "antd-mobile";
import { setStorage, getStorage, removeStorage, highlight } from 'common/util';
import "./index.less";

const mtl = window.mtl || {};

export default class Search extends Component {
    state = {
        show: false,
        value: "",
        clientHeight: 0,
        historyData: null,
        showHistory:true,
        showIcon:false
    }

    // 点击搜索所要做的操作
    onSearch = () => {
        this.searchFromValue();
    }

    searchFromValue = ()=>{
        const { value } = this.state;

        if(value !== '' && value.replace(/\s+/g,'') === ''){
            Toast.info("请输入搜索关键字", 2, null, false);
            this.setState({
                show: false,
                value: '',
                showHistory: true,
            })
        }else{
            let grep = value.replace(/\s+/g,''); // 清除搜索框内部输入文字的所有的空格符；
            this.setstorage(grep);
        }
    }

    setstorage = value => {
        let param = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '');
        let { currentIndex } = qs.parse(param);

        let newInputText = new Array(value);
        let historyData = getStorage("historyData")? JSON.parse(getStorage("historyData")) : [];
        let result = [...new Set(newInputText.concat(historyData))];

        switch(currentIndex){
            case "1":
                value ? setStorage("backlogInputText",value) : removeStorage("backlogInputText");
                break;
            case "2":
                value ? setStorage("historyInputText",value) : removeStorage("historyInputText");
                break;
        }
        setStorage("historyData",JSON.stringify(result));
        mtl.navigateBack();
    }

    onValueChange = e => {
        if( e.target.value ){
            this.setState({
                show: true,
                value: e.target.value,
                showHistory: false
            });
        }else{
            this.setState({
                show: false,
                value: "",
                showHistory: true,
            });
        }
        this.getHeight();
    }

    // 清除搜索框中的值
    clearValue = () => {
        this.setState({
            value: "",
            show: false,
            showHistory: true,
        });
        this.getHeight();
    }

    // 清除历史记录
    clearHistory = () => {
        let clearHistoryData = removeStorage("historyData");
        this.setState({
            historyData:clearHistoryData,
            showIcon:false
        })
    }

    showMore = () => {
        this.setState({
            showIcon:false
        });
        ReactDOM.findDOMNode(this.lv).style.height = "8rem";
        ReactDOM.findDOMNode(this.lv).style.overflow = "hidden";
    }


    setInputValue = e => {
        let value;
        if(e.target.dataset.type === "text"){
            value = e.target.childNodes[0].innerHTML;
        }else{
            value = e.target.childNodes[0].data;
        }
        if(value){
            this.setState({
                value,
                show: true
            })
            this.setstorage(value);
        }
    }

    // 点击模糊搜索查询出来的值将其渲染到搜索框中
    fillText = item =>{
        this.setState({
            value:item
        });
        this.setstorage(item);
    }

    // 判断缓存中的数据是否超过三行的高度，如果超过了那么就隐藏显示
    getHeight = () => {
        let historyData = getStorage("historyData") && JSON.parse(getStorage("historyData"));
        this.setState({
            historyData
        }, () => {
            let height = ReactDOM.findDOMNode(this.lv).getBoundingClientRect().height;
            if(ReactDOM.findDOMNode(this.lv).childNodes[0]) {
                let childHeight = ReactDOM.findDOMNode(this.lv).childNodes[0].getBoundingClientRect().height;
                if( height > 4 * childHeight ){
                    this.setState({
                        showIcon:true
                    })
                    ReactDOM.findDOMNode(this.lv).style.height = "2.4rem";
                    ReactDOM.findDOMNode(this.lv).style.overflow = "hidden";
                }
            }
        })
    }

    onkeyDown = e =>{
        if(e.keyCode === 13){
            this.searchFromValue();
        }
    }


    componentDidMount(){
        let clientHeight = document.documentElement.clientHeight;
        document.querySelector(".tab-search-input").focus();
        document.addEventListener("keydown",this.onkeyDown);

        let inputValue;
        let param = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '');
        let { currentIndex } = qs.parse(param);
        switch(currentIndex){
            case "1":
                inputValue = getStorage("backlogInputText");
                break;
            case "2":
                inputValue = getStorage("historyInputText");
                break;
        }
        if(inputValue){
            this.setState({
                value: inputValue,
                show: true,
                showHistory: false,
                clientHeight
            })
        }else{
            this.setState({
                value: "",
                show: false,
                showHistory: true,
                clientHeight
            })
        }
        this.getHeight();

    }

    componentWillUnmount(){
        document.removeEventListener("keydown",this.onkeyDown);
    }

    render() {
        const { show, clientHeight, value, historyData, showHistory, showIcon } = this.state;
        let showDelete = show ? "block" : "none";
        let showView = showHistory ? "block" : "none";
        let showDim = showHistory ? "none" : "block";
        let showIconstyle = showIcon ? "block" : "none";

        let historyList = historyData?.map((item,index)=>{
            if(item === '') return;
            return (
                <div key={index} onClick={this.setInputValue} data-type="text">
                    <div>{item}</div>
                </div>
            )
        })

        let dimSearch;
        if (value.replace(/\s+/g,'') !== ''){
            let newValue = value.replace(/\s+/g,'');
            let data = historyData?.filter(res => res.includes(newValue));
            dimSearch = data?.map( (item, index) => {
                let result = highlight(item, newValue);
                return <div key={index} onClick={()=>this.fillText(item)} dangerouslySetInnerHTML={{__html:result}}></div>
            });
        }

        return (
            <div style={{height:clientHeight,background:"#FFFFFF"}}>
                <div className="search-page-top">
                    <span className="tab-search-img"></span>
                    <input value={value || ""} type="search" className="tab-search-input" onChange={this.onValueChange} placeholder="车牌号、派车单号、装货单位、卸货单位"></input>
                    <span className="tab-search-delete" style={{display:showDelete}} onClick={this.clearValue}></span>
                    <span className="tab-search-right" onClick={this.onSearch }>搜索</span>
                </div>
                <div className="search-dim" style={{display:showDim}}>
                    {dimSearch}
                </div>
                <div className="search-page-history" style={{display:showView}}>
                    <div>
                        <div>搜索历史</div>
                        <div className="history-icon-delete" onClick={this.clearHistory}></div>
                    </div>
                    <div className="history-body" ref={el => this.lv = el}>
                        {historyList}
                    </div>
                    <div style={{display:showIconstyle}}>
                        <div onClick={this.showMore}>
                            <div className="history-body-more"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
